export const defaultOtherCategoriesPageSize = 6;
